import React, { useState } from "react";
import { Button } from "react-bootstrap";

const SyaratKetentuan = ({ onCancel, onConfirm }) => {
  const [agreeTnc, setAgreeTnc] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);

  const canProceed = agreeTnc && agreePrivacy;

  return (
    <>
      <div className="com-modal-bg"></div>
      <div className="com-modal d-flex flex-center">
        <div className="com-modal-dialog">
          <div
            className="com-modal-content d-flex flex-column"
            style={{ padding: "16px", gap: "16px" }}
          >
            <div style={{ fontSize: "20px" }} className="fw-semibold">
              Syarat & Ketentuan dan Kebijakan Privasi
            </div>
            <p className="text-secondary mb-0">
              Untuk melanjutkan, mohon setujui Syarat & Ketentuan serta
              Kebijakan Privasi kami terlebih dahulu.
            </p>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="tncAgreeCheckbox"
                checked={agreeTnc}
                onChange={(e) => setAgreeTnc(e.target.checked)}
              />
              <label className="ms-2 font-sm" htmlFor="tncAgreeCheckbox">
                Saya menyetujui{" "}
                <a
                  href="/syarat-dan-ketentuan"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold text-primary"
                >
                  Syarat & Ketentuan
                </a>{" "}
                dari Caready
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="privacyAgreeCheckbox"
                checked={agreePrivacy}
                onChange={(e) => setAgreePrivacy(e.target.checked)}
              />
              <label className="ms-2 font-sm" htmlFor="privacyAgreeCheckbox">
                Saya menyetujui{" "}
                <a
                  href="/kebijakan-privasi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold text-primary"
                >
                  Kebijakan Privasi
                </a>{" "}
                dari Caready
              </label>
            </div>
            <div
              className="d-flex justify-content-end w-100"
              style={{ gap: "16px" }}
            >
              <Button className="btn-upload" onClick={onCancel}>
                Batal
              </Button>
              <Button
                className="filter-button fw-semibold"
                onClick={onConfirm}
                disabled={!canProceed}
              >
                Lanjut
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SyaratKetentuan;
